import React from "react";
import {
  Row,
  Column,
  FormGroup,
  Checkbox,
  RadioButtonGroup,
  RadioButton,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";

const TrainingAreaForm = ({
  disabled,
  register,
  control,
  errors,
  candidature,
  selectedTrainingProviders,
  setSelectedTrainingProviders,
  selectedTrainingAreas,
  setSelectedTrainingAreas,
}) => {
  const { data: traningAreas } = useGet("/lookup/training-areas");
  const { data: traningProviders } = useGet("/lookup/training-providers");

  const updateTrainingPreferences = (id, checked) => {
    setSelectedTrainingAreas(
      updateCheckedOptions(selectedTrainingAreas, id, checked)
    );
  };

  const updatePastTrainings = (id, checked) => {
    setSelectedTrainingProviders(
      updateCheckedOptions(selectedTrainingProviders, id, checked)
    );
  };

  useEffect(() => {}, [
    candidature,
    selectedTrainingProviders,
    selectedTrainingAreas,
  ]);

  return (
    <FormGroup legendText="FORMAÇÕES" className="section-header">
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={6} md={6} lg={6} className="required">
            <RadioButtonGroup
              name="hasReceivedRelevantBusinessPerformanceTraining"
              disabled={disabled}
              legendText="32. Já recebeu algum treinamento relevante para o início e/ou melhorar o desempenho do seu negócio?"
              valueSelected={candidature?.hasReceivedRelevantBusinessPerformanceTraining?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="performance-y"
                {...register("hasReceivedRelevantBusinessPerformanceTraining")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="performance-n"
                {...register("hasReceivedRelevantBusinessPerformanceTraining")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasReceivedRelevantBusinessPerformanceTraining?.message}
            </p>
          </Column>
          {selectedTrainingProviders && (
            <Column xml={12} sm={6} md={6} lg={6} className="required">
              <legend className="bx--label required">
                32.1. Se sim, quem ofereceu o treinamento?
              </legend>

              {traningProviders.map((tp) => (
                <DynamicCheckbox
                  key={"tp" + tp.id}
                  id={tp.id}
                  disabled={disabled}
                  label={tp.description}
                  updateItems={updatePastTrainings}
                  checked={isCandidatureOptionChecked(
                    selectedTrainingProviders,
                    tp.id
                  )}
                />
              ))}
            </Column>
          )}
        </Row>
        <Row>
          <Column xml={12} sm={12} md={12} lg={12} className="required">
            <RadioButtonGroup
              name="confirmsAvailabilityForTraining"
              disabled={disabled}
              legendText="33. Para poder concorrer a subvenção, neste projecto, é requerido que o candidato participe nas formações que visam o fortalecimento das suas capacidades como empreendedor. Confirma que estará disponível para participar nas seguintes formações disponibilizadas: (i) iniciativa pessoal (36h), (ii) competências digitais (20h), (iii)marketing (20h) e (iv) serviços financeiros (36h). "
              valueSelected={candidature?.confirmsAvailabilityForTraining?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="training-y"
                {...register("confirmsAvailabilityForTraining")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="training-n"
                {...register("confirmsAvailabilityForTraining")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.confirmsAvailabilityForTraining?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      {selectedTrainingAreas && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label required">
            34. Que tipo de capacitação técnica gostarias de ter acesso?
          </legend>
          <p>Seleciona as tuas 3 opções por ordem de preferência:</p>

          <Row>
            <Column sm={12} md={12} lg={12}>
              {traningAreas.map((x) => (
                <DynamicCheckbox
                  key={"ta" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updateTrainingPreferences}
                  checked={isCandidatureOptionChecked(
                    selectedTrainingAreas,
                    x.id
                  )}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
      <fieldset className="bx--fieldset">
        <Row>
          <Column xml={12} sm={6} md={6} lg={6} className="required">
            <RadioButtonGroup
              name="hasSpecialNeedsForTraining"
              disabled={disabled}
              legendText="35. Possui alguma necessidade especial  para a participação nas formações?"
              valueSelected={candidature?.hasSpecialNeedsForTraining?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="special-y"
                {...register("hasSpecialNeedsForTraining")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="special-n"
                {...register("hasSpecialNeedsForTraining")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasSpecialNeedsForTraining?.message}
            </p>
          </Column>
          <Column xml={12} sm={6} md={6} lg={6} className="required">
            <RadioButtonGroup
              name="isAvailableForTrainingOutsideOfResidence"
              disabled={disabled}
              legendText="36. Estás disponível para ter formação noutra zona fora da tua zona de residência? "
              valueSelected={candidature?.isAvailableForTrainingOutsideOfResidence?.toString()}
            >
              <RadioButton
                labelText="Sim"
                value="true"
                id="outside-y"
                {...register("isAvailableForTrainingOutsideOfResidence")}
              />
              <RadioButton
                labelText="Não"
                value="false"
                id="outside-n"
                {...register("isAvailableForTrainingOutsideOfResidence")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.isAvailableForTrainingOutsideOfResidence?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

TrainingAreaForm.defaultProps = {
  disabled: false,
};

export default TrainingAreaForm;
